export enum ChainingPatientServiceHistoryStatus {
    added = 'created',
    updated = 'updated',
    deleted = 'deleted',
    validated = 'validated',
    invalidated = 'pending',
    billed = 'billed'
}
